/** |READ ME| **********************************************************************************************************

"Common"

JavaScript File

Ver.20204028

------------------------------------------------------------------------------------------------------------------------

01. Common
02. Carrier
03. Constructor
04. Header

********************************************************************************************************** |READ ME| **/

/** |01. Common | >> ******************************************************************************* >> START **/

var ua = navigator.userAgent;
var uaPad = window.navigator.userAgent.toLowerCase();
var rsp = 750;
var full = 1300;
var scroll;
var scrollAdd = 0;
var scrollTimer = 0;
var flgTouch = false;

/** |01. Common | << ********************************************************************************* << END **/

/** |02. Carrier | >> ******************************************************************************* >> START **/

if (ua.indexOf("iPhone") > 0 || ua.indexOf("iPod") > 0 || ua.indexOf("Android") > 0 && ua.indexOf("Mobile") > 0) {
    ua = "sp";
} else if (ua.indexOf("iPad") > 0 || ua.indexOf("Android") > 0) {
    ua = "tab";
} else {
    ua = "pc";
}
if (uaPad.indexOf("ipad") > -1 || uaPad.indexOf("macintosh") > -1 && "ontouchend" in document) {
    ua = "tab";
}

/** |02. Carrier | << ********************************************************************************* << END **/

/** |03. Constructor | >> ******************************************************************************* >> START **/

$(function() {
    setGlobalNavi();
    setPdcItem();
    setThumbOverVideo();
});

/** |03. Constructor | << ********************************************************************************* << END **/

/** |04. Header | >> ******************************************************************************* >> START **/

function setGlobalNavi() {

    $("#header .spmenu").click(function() {
        if(!($("#header .pulldown").is(':animated'))){
            if($(this).hasClass("open")){
              $("#header .spmenu").removeClass("open"); 
              $("#header").removeClass("sp-menu-open"); 
              $("#header .pulldown").removeClass("open");
              $("#header .pulldown").stop().animate({ opacity: 0 },250, "easeOutQuad", function() {
                  $("#header .pulldown").css({ "display": "none" });
              });
            }else{
              $("#header .spmenu").addClass("open"); 
              $("#header").addClass("sp-menu-open"); 
              $("#header .pulldown").css({ "display": "block" });
              $("#header .pulldown").stop().animate({ opacity: 1 },250, "easeOutQuad", function() {
              $("#header .pulldown").addClass("open");
              }); 
            }
        }
    });
    $("#header .close,#header .pulldown-bg-close").click(function() {
        $("#header .spmenu").removeClass("open"); 
        $("#header").removeClass("sp-menu-open"); 
        $("#header .pulldown").removeClass("open");
        $("#header .pulldown").stop().animate({ opacity: 0 },250, "easeOutQuad", function() {
            $("#header .pulldown").css({ "display": "none" });
        });
    });

    /*
    if ($("#header .account-ico").length) {
        if (ua == "pc") {
            $("#header .account-ico").mouseover(function() {
                $("#header .account-ico").addClass("open");
            });
            $("#header .account-ico").mouseout(function() {
                $("#header .account-ico").removeClass("open");
            });
        } else {
            $("#header .account-ico").click(function() {
                if ($("#header .account-ico").hasClass("open") == false) {
                    $("#header .account-ico").addClass("open");
                } else {
                    $("#header .account-ico").removeClass("open");
                }
            });
        }
    }
    */
  
    if ($("#header #lang_menu").length) {
        var lang = $("#shiro8_translate_form option:selected").attr("value");
        if (lang == "en") {
            $("#header .lang-btn-en").addClass("act");
            $("#header .lang-btn-jp").click(function() {
                $("#shiro8_translate_form option").removeAttr("selected")
                $("#shiro8_translate_form option[value=jp]").attr("selected", "selected");
                $("#shiro8_translate_form").submit();
            });
        } else {
            $("#header .lang-btn-jp").addClass("act");
            $("#header .lang-btn-en").click(function() {
                $("#shiro8_translate_form option").removeAttr("selected");
                $("#shiro8_translate_form option[value=en]").attr("selected", "selected");
                $("#shiro8_translate_form").submit();
            });
        }
    }

    $(".global-nav-sub--pd").hover(
        function (){
          var hei = $(this).find(".global-nav-sub-box").outerHeight();
          $(this).find(".global-nav-sub-inn").css({"height":hei + "px"});
        },
        function () {
          $(this).find(".global-nav-sub-inn").css({"height":0});
        }
    );

    var windowScroll = $(window).scrollTop();
    $(window).scroll(function () {
      var addScroll  = $(this).scrollTop();
      $("#check").html(windowScroll);
        if (windowScroll < addScroll && windowScroll > 120) {
          $("#header").addClass("header--hidden");
        } else {
          $("#header").removeClass("header--hidden");
        }
        if($(this).scrollTop() == 0){
          $("#header").addClass("header--touchtop");   
        }else{  
          $("#header").removeClass("header--touchtop");  
        }
        windowScroll = addScroll;
    });

    const hedTgls = document.getElementsByClassName("header-tgl-list");
    let tit = hedTgls[0].firstElementChild
    let wrap = hedTgls[0].lastElementChild
    tit.addEventListener("click", e => {
      let hei = wrap.firstElementChild.offsetHeight;
      if(tit.classList.contains("open")){
        tit.classList.remove("open");
        wrap.style.height = 0 + 'px';
      }else{
        tit.classList.add("open");
        wrap.style.height = hei + 'px';
      }
    });

}

/** |04. Header | << ******************************************************************************* << END **/

/** |05. Product | >> ******************************************************************************* >> START **/

function setPdcItem() {
   if (ua == "pc") {
        actPdcScroll();
        $(window).scroll(function() {
            actPdcScroll();
        });
    }
}

function actPdcScroll() {
    scroll = $(window).scrollTop();
}

/** |05. Product | << ******************************************************************************* << END **/

/** |06. Thumb Over Video | >> ******************************************************************** >> START **/

/*
 * 一覧ページのカード（.grid__item.thumb_over）で custom.thumb_over メタフィールドに
 * 動画が指定されている場合、ロールオーバー中だけ動画を再生する。
 * ファセット絞り込みでグリッドが再描画されても効くように、イベントは委譲でバインドする。
 */
function setThumbOverVideo() {

    function getVideo(item) {
        return item.querySelector(".card__media video");
    }

    $(document).on("mouseenter", ".grid__item.thumb_over", function() {
        var video = getVideo(this);
        if (!video) return;
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute("playsinline", "playsinline");
        var playing = video.play();
        if (playing && playing.catch) {
            playing.catch(function() {});
        }
    });

    $(document).on("mouseleave", ".grid__item.thumb_over", function() {
        var video = getVideo(this);
        if (!video) return;
        video.pause();
        try {
            video.currentTime = 0;
        } catch (e) {}
    });

}

/** |06. Thumb Over Video | << ******************************************************************** << END **/
